import produce from 'immer';
import { AnyAction } from 'redux';
import { PUT_NICKNAME_REQUEST, PUT_NICKNAME_SUCCESS, PUT_NICKNAME_FAILURE, PUT_NICKNAME_INITIAL } from '../../actions';

export type putNicknameType = {
  putNicknameResult: {
    isLoading: boolean;
    isLoaded: boolean;
    result: number;
  };
};

const initialState: putNicknameType = {
  putNicknameResult: {
    isLoading: false,
    isLoaded: false,
    result: -1,
  },
};

const putNicknameReducer = (state = initialState, action: AnyAction): putNicknameType => {
  return produce(state, (stateDraft) => {
    const draft = stateDraft;
    switch (action.type) {
      case PUT_NICKNAME_REQUEST:
        draft.putNicknameResult.isLoading = true;
        draft.putNicknameResult.isLoaded = false;
        draft.putNicknameResult.result = -1;
        break;
      case PUT_NICKNAME_SUCCESS:
        draft.putNicknameResult.isLoading = false;
        draft.putNicknameResult.isLoaded = true;
        draft.putNicknameResult.result = action.data.result;
        break;
      case PUT_NICKNAME_FAILURE:
        draft.putNicknameResult.isLoading = false;
        draft.putNicknameResult.isLoaded = false;
        draft.putNicknameResult.result = -1;
        break;
      case PUT_NICKNAME_INITIAL:
        draft.putNicknameResult.isLoading = false;
        draft.putNicknameResult.isLoaded = false;
        draft.putNicknameResult.result = -1;
        break;
      default:
        break;
    }
  });
};

export default putNicknameReducer;
